import ApiConfig from "../Config";
import apiService from "../services/apiService";

const adminService = {
  getAdminUsers: (token) =>
    apiService.get(ApiConfig.getAdminUsers, {
      headers: {
        "x-access-token": token,
      },
    }),
};
export default adminService;
